<template>
  <div :class="{ hide: hide }" class="modal-overlay w-full h-full">
    <div class="contactUsForm popup">
      <popup-header :title="title" @close="closePopup" />
      <div class="popup__content popup__content--contact-us-form"></div>
    </div>
  </div>
</template>

<script>
import PopupHeader from "@/components/PopupHeader";
export default {
  name: "ContactUsForm",
  components: { PopupHeader },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    formId: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: "Contact Sales",
    },
  },
  data() {
    return {
      hide: true,
    };
  },
  methods: {
    closePopup() {
      this.$emit("close");
    },
    createForm(value) {
      window.hbspt.forms.create({
        region: "eu1",
        portalId: "25442797",
        formId: this.formId,
        target: ".popup__content--contact-us-form",
      });
      setTimeout(() => {
        this.hide = !value;
      }, 200);
    },
  },
  watch: {
    show: {
      handler(value) {
        if (value) {
          if (!window.hbspt) {
            const script = document.createElement("script");
            script.src = "https://js-eu1.hsforms.net/forms/embed/v2.js";
            document.body.appendChild(script);
            script.addEventListener("load", () => {
              this.createForm(value);
            });
          } else {
            this.createForm(value);
          }
        } else {
          this.hide = !value;
        }
      },
    },
  },
};
</script>

<style>
.hide {
  @apply hidden;
}
.contactUsForm .popup__content {
  @apply flex justify-center px-8 min-h-[480px];
}
.popup__content--contact-us-form {
  @apply md:w-[600px];
}
.popup__content--book-meeting {
  @apply md:w-[800px] xl:w-[1100px];
}
</style>
